<template>
  <b-card class="rounded-lg">
    <template #header>
      <div class="d-flex justify-content-between align-items-center w-100 pb-1" style="border-bottom: 2px solid rgb(238, 238, 238);">
        <h4 class="text-dark m-0">
          Notes
        </h4>
      </div>
    </template>
    

    <div class="card-body">
      <div v-if="getValueFromSource(consultationData, 'doctor_notes', []) && getValueFromSource(consultationData, 'doctor_notes', []).length">
        <div v-for="doctor_note in getValueFromSource(consultationData, 'doctor_notes', [])" :key="doctor_note._id">
          <div class="mb-1">
            <h4 class="lead text-muted mb-1"> {{ formatDate(getValueFromSource(doctor_note, 'created'), 'yyyy-MM-dd') }}</h4>
            <p class="m-0 lead">
              {{ getValueFromSource(doctor_note, 'note') }}
            </p>
          </div>
        </div>
      </div>

      <div v-else>
        <p class="lead">None at the moment.</p>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BImg,
  BRow,
  BCol,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BDropdown,
  BDropdownItem,
  BDropdownGroup
} from 'bootstrap-vue'

import UserViewActionCard from "./UserViewActionCard.vue";

export default {
  components: {
    BImg,
    BRow,
    BCol,
    BCard,
    BBadge,
    BAlert,
    BAvatar,
    BButton,
    BDropdown,
    BDropdownItem,
    BDropdownGroup,

    UserViewActionCard,
  },
  props: {
    consultationData: {
      type: Object,
      default: null,
      required: false,
    },
  },
  setup() {},
}
</script>

<style scoped>
.profile-highlight {
  font-size: 18px !important;
}
.profile-highlight-title {
  font-size: 16px !important;
  color: lightgray;
  font-weight: normal;
}

.patient-name {
  font-size: 25px;
}
</style>
